import type { InjectionKey, Ref } from 'vue'

export const CardInjectionKey = Symbol('CardContext') as InjectionKey<CardContext>
export interface CardContext {
  headerPlacement: Ref<'inside'|'outside'>
  isOpen: Ref<boolean>
}
